import BaseEnum from "./base_enum.js";

class DocumentKindEnumDesc extends BaseEnum {

  name() {
    return "document_kind";
  }

  rawValues() {
    return ["project_declaration", "downloadable_declaration"];
  }

}

const DocumentKindEnum = new DocumentKindEnumDesc();
export default DocumentKindEnum;